import { clone, filter, flatten, groupBy, isArray, map, max, pipe, prop, uniq, uniqBy, } from 'lodash/fp';
export const toggleItem = (list, id) => list.includes(id) ? list.filter((i) => i != id) : [...list, id];
export const nest = (items, id = null, link = 'parent') => items
    .filter((item) => item[link] === id)
    .map((item) => ({ element: item, children: nest(items, item.id) }));
export function getTree(items) {
    const byParent = groupBy('parent', items);
    if (!items.length && !!byParent)
        return [];
    const getItems = (nodes, lvl, parent) => {
        var _a;
        return (_a = nodes === null || nodes === void 0 ? void 0 : nodes.map) === null || _a === void 0 ? void 0 : _a.call(nodes, ({ id, name, level }) => {
            const node = {
                parent,
                id,
                name,
                visible: true,
                level: level !== undefined ? level : lvl,
            };
            node.children = byParent[id] ? getItems(byParent[id], lvl + 1, node) : [];
            return node;
        });
    };
    return getItems(byParent['null'], 1);
}
export function getChildrenIds(nodes, ids = []) {
    return nodes.reduce((acc, { id, children }) => {
        if (children === null || children === void 0 ? void 0 : children.length) {
            return getChildrenIds(children, acc);
        }
        return [...acc, id];
    }, ids);
}
export function findNodeOfTree(data, check) {
    const findNode = (nodes = []) => {
        for (let i = 0; i < nodes.length; i += 1) {
            const item = nodes[i];
            if (isArray(item.children)) {
                const node = findNode(item.children);
                if (node) {
                    return node;
                }
            }
            if (check(item)) {
                return item;
            }
        }
        return undefined;
    };
    return findNode(data);
}
export function filterNodesOfTree(data, check) {
    const findNodes = (nodes = []) => {
        const nextNodes = [];
        for (let i = 0; i < nodes.length; i += 1) {
            if (isArray(nodes[i].children)) {
                const nextChildren = findNodes(nodes[i].children);
                if (nextChildren.length) {
                    const item = clone(nodes[i]);
                    item.children = nextChildren;
                    nextNodes.push(item);
                    continue;
                }
            }
            if (check(nodes[i])) {
                nextNodes.push(nodes[i]);
            }
        }
        return nextNodes;
    };
    return findNodes(data);
}
export function findNodes(nodes, ids) {
    return nodes.reduce((acc, node) => {
        var _a;
        if (ids.includes(node.id)) {
            return [...acc, node];
        }
        else if ((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) {
            return [...acc, ...findNodes(node.children, ids)];
        }
        return acc;
    }, []);
}
export function normalizeToEndNodes(tree, ids) {
    return getChildrenIds(findNodes(tree, ids));
}
export function getNodeParents(node, parentKey = 'parent', valueKey) {
    const parents = [];
    const traverse = (node) => {
        if (node === null || node === void 0 ? void 0 : node[parentKey]) {
            traverse(node[parentKey]);
            if (valueKey) {
                parents.push(node[parentKey][valueKey]);
            }
            else {
                parents.push(node[parentKey]);
            }
        }
    };
    traverse(node);
    return parents;
}
export const getIsAllSelected = (nodes, selected) => nodes.every(({ id, children }) => (children === null || children === void 0 ? void 0 : children.length)
    ? getIsAllSelected(children, selected)
    : selected.includes(id));
export const getAtLeastOneSelected = (nodes, selected) => nodes.some(({ id, children }) => (children === null || children === void 0 ? void 0 : children.length)
    ? getAtLeastOneSelected(children, selected)
    : selected.includes(id));
export const getStatisticsByLevels = pipe([
    map((node) => [node, ...getNodeParents(node)]),
    flatten,
    uniqBy('id'),
    groupBy(prop('level')),
]);
export function getCalculatedSelection(nodes, selected) {
    const lvl = [];
    const checked = [];
    const selectedOnLevel = [];
    const registerSelectedNode = (node) => {
        var _a;
        selectedOnLevel.push({
            level: node.level,
            id: node.id,
            is_lowest: !((_a = node.children) === null || _a === void 0 ? void 0 : _a.length),
        });
    };
    const scan = (node) => {
        if (checked.includes(node.id))
            return;
        checked.push(node.id);
        if (node.parent) {
            if (getIsAllSelected(node.children, selected)) {
                registerSelectedNode(node);
                scan(node.parent);
            }
            else if (getAtLeastOneSelected(node.children, selected)) {
                scan(node.parent);
                lvl.push(node.level + 1);
            }
            else {
                lvl.push(node.level + 1);
                scan(node.parent);
            }
        }
        else {
            if (getIsAllSelected(node.children, selected)) {
                registerSelectedNode(node);
                lvl.push(1);
            }
            else {
                lvl.push(node.level + 1);
            }
        }
    };
    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        scan(node);
    }
    const level = max(uniq(lvl));
    return {
        level,
        selected: filter((nodeStat) => {
            if (nodeStat.level === level) {
                return true;
            }
            else if (nodeStat.level < level && nodeStat.is_lowest) {
                return true;
            }
            else {
                return false;
            }
        }, selectedOnLevel),
    };
}
//# sourceMappingURL=helpers.js.map